/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExecutionsHistory
 */
export interface ExecutionsHistory {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    facility_id: string;
    /**
     * 
     */
    lead_id: string;
    /**
     * 
     */
    createdAt: string;
    /**
     * 
     */
    lead_full_name: string;
}

/**
 * Check if a given object implements the ExecutionsHistory interface.
 */
export function instanceOfExecutionsHistory(value: object): value is ExecutionsHistory {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('facility_id' in value) || value['facility_id'] === undefined) return false;
    if (!('lead_id' in value) || value['lead_id'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('lead_full_name' in value) || value['lead_full_name'] === undefined) return false;
    return true;
}

export function ExecutionsHistoryFromJSON(json: any): ExecutionsHistory {
    return ExecutionsHistoryFromJSONTyped(json, false);
}

export function ExecutionsHistoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecutionsHistory {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'facility_id': json['facility_id'],
        'lead_id': json['lead_id'],
        'createdAt': json['createdAt'],
        'lead_full_name': json['lead_full_name'],
    };
}

export function ExecutionsHistoryToJSON(json: any): ExecutionsHistory {
    return ExecutionsHistoryToJSONTyped(json, false);
}

export function ExecutionsHistoryToJSONTyped(value?: ExecutionsHistory | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'facility_id': value['facility_id'],
        'lead_id': value['lead_id'],
        'createdAt': value['createdAt'],
        'lead_full_name': value['lead_full_name'],
    };
}

